interface VideoEmbedProps {
  videoId: string;
  title?: string;
  className?: string;
}

export const VideoEmbed = ({ videoId, title = "Video", className = "" }: VideoEmbedProps) => {
  return (
    <div className={`relative w-full overflow-hidden rounded-lg shadow-lg ${className}`}>
      <div className="relative pb-[56.25%]">
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?controls=0&modestbranding=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={false}
          loading="lazy"
        />
      </div>
    </div>
  );
};
